import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-review-slider-yuri';
const html = `
<div>
  <div data-attribute="product-review" class="product-review" style="display: none;">
    <div data-attribute="wrap-product-review" class="wrap-product-review">
      <div class="product-left">
        <img data-attribute="product-image"
         src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dd481d4bd1f27ff434bc.avif?w=500" alt="">
      </div>
      <div class="product-right">
        <div data-attribute="product-name" class="product-name">Collagen Night Wrapping Mask</div>
        <div class="wrap-price">
          <span data-attribute="current-price" class="current-price">$12.99</span>
          <span data-attribute="old-price" class="old-price">$14.99</span>
        </div>
        <div class="wrap-purchased">
          <span class="icon-purchased">
            <svg class="purchase-date-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="11"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
              stroke-linejoin="round" style="display: block;">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
          </span>
          <span data-attribute="purchase-date" class="purchase-date">Purchased on October, 2026</span>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div data-attribute="wrap-card" class="wrap-card" data-color-highlight="#cb6387">
      <div data-attribute="block-rated" data-show="true" class="block-rated">
        <div class="star-icons">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path
              d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
              fill="currentColor" />
          </svg>
        </div>
        <div data-attribute="rating-value" class="rating-value">
          <p>Rated <strong>4.9/5</strong> based on 1,200+ reviews</p>
        </div>
      </div>
      <div data-attribute="card-title" data-show="true" class="card-title">
        <h2 style="text-align:center;">Join Over 10,000+ <span style="color:hsl( 339, 50%, 59% );"><i>Happy
              Customers</i></span></h2>
      </div>
      <div class="wrap-review-slider">
        <div class="swiper">
          <div data-attribute="list-item" class="swiper-wrapper" data-col-per-view="3" data-space-between="16">
            <div data-attribute="item" class="swiper-slide">
              <div class="wrap-item">
                <div class="wrap-review-image">
                  <img data-attribute="review-image"
                    src="https://cdn.skyfastimg.com/images/2026/05/07/image-69fbf942b1aec8f61ad7e403.webp" alt="">
                </div>
                <div class="wrap-review-content">
                  <div class="group-stars">
                    <div data-attribute="star-item" data-value="5" class="wrap-stars">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                    </div>
                    <div class="wrap-reviewer-name">
                      <span data-attribute="reviewer-name">John Doe,30</span>
                      <span class="icon-verified">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                          <title>check-decagram</title>
                          <path
                            d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z"
                            fill="currentColor" />
                        </svg>
                      </span>
                      <span>Verified Buyer</span>
                    </div>
                  </div>
                  <div data-attribute="content-review" class="content-review">
                    <p>I was skeptical at first but I’m so glad a gave it a chance. This mask made my skin look amazing
                      and
                      the fine line that bothered me looked less visible. I wish bought it sooner</p>
                  </div>
                  <div data-purchase-date="Purchased on October, 2026" data-attribute="insert-product-reivew"
                    class="insert-product-reivew"></div>
                </div>
              </div>
            </div>
            <div data-attribute="item" class="swiper-slide">
              <div class="wrap-item">
                <div class="wrap-review-image">
                  <img data-attribute="review-image"
                    src="https://cdn.skyfastimg.com/images/2026/05/07/image-69fbf9749bf8b1d2d68cb30f.webp" alt="">
                </div>
                <div class="wrap-review-content">
                  <div class="group-stars">
                    <div data-attribute="star-item" data-value="5" class="wrap-stars">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                    </div>
                    <div class="wrap-reviewer-name">
                      <span data-attribute="reviewer-name">John Doe,30</span>
                      <span class="icon-verified">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                          <title>check-decagram</title>
                          <path
                            d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z"
                            fill="currentColor" />
                        </svg>
                      </span>
                      <span>Verified Buyer</span>
                    </div>
                  </div>
                  <div data-attribute="content-review" class="content-review">
                    <p>I was skeptical at first but I’m so glad a gave it a chance. This mask made my skin look amazing
                      and
                      the fine line that bothered me looked less visible. I wish bought it sooner</p>
                  </div>
                  <div data-purchase-date="Purchased on October, 2027" data-attribute="insert-product-reivew"
                    class="insert-product-reivew"></div>
                </div>
              </div>
            </div>
            <div data-attribute="item" class="swiper-slide">
              <div class="wrap-item">
                <div class="wrap-review-image">
                  <img data-attribute="review-image"
                    src="https://cdn.skyfastimg.com/images/2026/05/07/image-69fbf9d4b84d46ae99518d2a.webp" alt="">
                </div>
                <div class="wrap-review-content">
                  <div class="group-stars">
                    <div data-attribute="star-item" data-value="5" class="wrap-stars">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>star</title>
                        <path
                          d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                          fill="currentColor" />
                      </svg>
                    </div>
                    <div class="wrap-reviewer-name">
                      <span data-attribute="reviewer-name">John Doe,30</span>
                      <span class="icon-verified">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                          <title>check-decagram</title>
                          <path
                            d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z"
                            fill="currentColor" />
                        </svg>
                      </span>
                      <span>Verified Buyer</span>
                    </div>
                  </div>
                  <div data-attribute="content-review" class="content-review">
                    <p>I was skeptical at first but I’m so glad a gave it a chance. This mask made my skin look amazing
                      and
                      the fine line that bothered me looked less visible. I wish bought it sooner</p>
                  </div>
                  <div data-purchase-date="Purchased on October, 2028" data-attribute="insert-product-reivew"
                    class="insert-product-reivew"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-attribute="pagination" class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
